(() => {
  if (window.amaroInteractions) return;
  window.amaroInteractions = true;
  const init = () => {
    const token = `amaro-${Date.now()}`;
    let active, returning = false, previousFocus, notice, noticeTimer, selectId = 0;
    const cartVisible = () => document.querySelector('cart-drawer.open') || document.body.classList.contains('amaro-page-cart');
    const dismissNotice = () => { if (notice) notice.hidden = true; clearTimeout(noticeTimer); };
    const positionNotice = () => {
      if (!notice || notice.hidden || notice.dataset.inline === 'true') return;
      const sticky = document.querySelector('product-cart-sticky.active');
      const top = sticky?.getBoundingClientRect().top;
      notice.style.bottom = top < innerHeight ? `${Math.max(24, innerHeight - top + 12)}px` : '';
      notice.style.maxHeight = top < innerHeight ? `${Math.max(96, Math.min(290, top - 80))}px` : '';
    };
    const visibleDrawer = () => document.querySelector('cart-drawer.open') || document.querySelector('#product-quick-view-drawer.open');
    const closeDrawer = drawer => {
      if (!drawer?.classList.contains('open')) return;
      const button = drawer.querySelector('.drawer-close[data-close-drawer],button[data-close-drawer]');
      // History closes quick view directly, without replaying its close-button click.
      if (drawer.id === 'product-quick-view-drawer') {
        drawer.classList.remove('open');
        if (!visibleDrawer()) document.body.classList.remove('no-scroll');
      }
      else if (button) button.click();
      else {
        drawer.classList.remove('open');
        document.body.classList.remove('no-scroll');
      }
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
    const synchronize = () => {
      if (cartVisible()) dismissNotice();
      if (notice?.dataset.inline === 'true' && !document.querySelector('#product-quick-view-drawer.open')) dismissNotice();
      positionNotice();
      const drawer = visibleDrawer();
      if (drawer) {
        if (!active && !returning) {
          previousFocus = document.activeElement;
          history.pushState({ ...history.state, searchParams: location.search.slice(1), amaroOverlay: token }, '');
        }
        active = drawer;
      } else if (active) {
        active = null;
        if (history.state?.amaroOverlay === token && !returning) {
          returning = true;
          history.back();
        }
      }
    };
    window.addEventListener('resize', positionNotice, { passive: true });
    window.addEventListener('popstate', () => {
      const drawer = active?.classList.contains('open') ? active : visibleDrawer();
      active = null;
      returning = false;
      if (drawer) closeDrawer(drawer);
    });
    document.addEventListener('keydown', event => {
      const dropdown = document.querySelector('details.amaro-select[open]');
      if (event.key === 'Escape' && dropdown) {
        event.preventDefault(); event.stopImmediatePropagation(); dropdown.open = false;
        dropdown.querySelector('summary').focus();
        return;
      }
      if (!['Escape', 'Backspace'].includes(event.key) || !visibleDrawer()) return;
      if (event.key === 'Backspace' && event.target.closest('input,textarea,select,[contenteditable="true"],[role="textbox"]')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (returning) return;
      if (history.state?.amaroOverlay === token) {
        returning = true;
        history.back();
      }
      else closeDrawer(visibleDrawer());
    }, true);
    // Keep explicit choices on the picker, which survives native option refreshes.
    // A new product/color body gets a new picker and must ask for sizes again.
    const quickSizeChoices = new WeakMap();
    const quickSizeState = field => {
      const picker = field?.closest('#product-quick-view-drawer variant-selector');
      if (!picker || field.classList.contains('color-swatches-box')) return;
      const fields = Array.from(picker.querySelectorAll('fieldset:not(.color-swatches-box)'));
      const value = field.querySelector('select')?.value ?? field.querySelector('input[type="radio"]:checked')?.value;
      const index = fields.indexOf(field);
      return { picker, index, value, chosen: !!value && quickSizeChoices.get(picker)?.get(index) === value };
    };
    const confirmQuickSize = control => {
      const state = quickSizeState(control.closest('fieldset'));
      if (!state) return;
      if (!quickSizeChoices.has(state.picker)) quickSizeChoices.set(state.picker, new Map());
      quickSizeChoices.get(state.picker).set(state.index, state.value);
    };
    const syncQuickSizePrompts = () => {
      const drawer = document.querySelector('#product-quick-view-drawer');
      const fields = Array.from(drawer?.querySelectorAll('variant-selector fieldset:not(.color-swatches-box)') || []);
      const missing = fields.filter(field => !quickSizeState(field)?.chosen);
      const warning = drawer?.querySelector('.amaro-quick-size-notice');
      if (!missing.length) warning?.remove();
      for (const field of fields) {
        const state = quickSizeState(field), summary = field.querySelector('.amaro-select summary');
        const select = field.querySelector('select');
        if (!summary || !select) continue;
        const label = state.chosen ? select.selectedOptions[0]?.textContent.trim() : 'Elige talla';
        if (summary.textContent !== label) summary.textContent = label;
        if (!state.chosen && warning?.isConnected) {
          summary.setAttribute('aria-invalid', 'true'); summary.setAttribute('aria-describedby', warning.id);
        } else { summary.removeAttribute('aria-invalid'); summary.removeAttribute('aria-describedby'); }
        field.querySelectorAll('.amaro-select-options button').forEach((button, index) => {
          button.setAttribute('aria-selected', String(state.chosen && select.options[index]?.selected));
        });
      }
    };
    const requireQuickSize = drawer => {
      const fields = Array.from(drawer.querySelectorAll('variant-selector fieldset:not(.color-swatches-box)'));
      const missing = fields.find(field => !quickSizeState(field)?.chosen);
      if (!missing) return false;
      let warning = drawer.querySelector('.amaro-quick-size-notice');
      if (!warning) {
        warning = document.createElement('p'); warning.className = 'amaro-quick-size-notice';
        warning.id = 'amaro-quick-size-required'; warning.setAttribute('role', 'alert');
        missing.closest('variant-selector').before(warning);
      }
      warning.textContent = fields.length > 1 ? 'Elige la talla de cada par antes de agregar.' : 'Elige tu talla antes de agregar el par.';
      syncQuickSizePrompts();
      requestAnimationFrame(() => {
        if (!missing.isConnected) return;
        missing.scrollIntoView({ block: 'center', behavior: 'instant' });
        const summary = missing.querySelector('.amaro-select summary');
        if (summary) { summary.focus({ preventScroll: true }); summary.parentElement.open = true; }
        else missing.querySelector('input:not(:disabled)')?.focus();
      });
      return true;
    };
    document.addEventListener('submit', event => {
      const drawer = event.target.closest('#product-quick-view-drawer');
      if (!drawer || !event.target.closest('product-form') || !requireQuickSize(drawer)) return;
      event.preventDefault(); event.stopImmediatePropagation();
    }, true);
    document.addEventListener('change', event => {
      if (event.isTrusted && event.target.matches('#product-quick-view-drawer variant-selector select,#product-quick-view-drawer variant-selector input[type="radio"]')) confirmQuickSize(event.target);
    }, true);
    const enhanceSelect = select => {
      if (select.dataset.amaroSelect) return;
      select.dataset.amaroSelect = 'true';
      const details = document.createElement('details');
      details.className = 'amaro-select';
      const summary = document.createElement('summary');
      const label = select.closest('fieldset')?.querySelector('legend strong')?.textContent.trim() || select.getAttribute('aria-label') || select.name || 'Selecciona una opción';
      summary.setAttribute('aria-label', label);
      summary.setAttribute('aria-haspopup', 'listbox');
      summary.setAttribute('aria-expanded', 'false');
      summary.textContent = select.selectedOptions[0]?.textContent.trim() || label;
      const list = document.createElement('div');
      list.className = 'amaro-select-options'; list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', label);
      list.id = `amaro-select-${++selectId}`;
      summary.setAttribute('aria-controls', list.id);
      for (const option of select.options) {
        const button = document.createElement('button');
        button.type = 'button'; button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', String(option.selected));
        button.textContent = option.textContent.trim(); button.disabled = option.disabled || select.disabled;
        button.addEventListener('click', () => {
          select.value = option.value;
          confirmQuickSize(select);
          summary.textContent = button.textContent;
          list.querySelectorAll('button').forEach(b => b.setAttribute('aria-selected', String(b === button)));
          details.open = false; summary.focus();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        list.append(button);
      }
      // Amaro stores most colors as separate products. Reuse the server-rendered
      // color links, while native options keep their existing variant behavior.
      if (select.closest('[data-amaro-pdp-options]') && select.closest('.color-swatches-box')) {
        const colors = select.closest('.product-media-info-inner')?.querySelectorAll('[data-amaro-product-colors] a') || [];
        for (const color of colors) {
          if (color.getAttribute('aria-current') === 'page') continue;
          const link = document.createElement('a');
          link.href = color.href;
          link.textContent = color.title || color.getAttribute('aria-label');
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          list.append(link);
        }
      }
      details.append(summary, list);
      select.after(details); select.hidden = true;
      const placeSuggestionOptions = () => {
        if (!details.open || !details.closest('.amaro-combos-buy,[data-amaro-pdp-options]')) return;
        const anchor = summary.getBoundingClientRect();
        const boundary = details.closest('.drawer-body')?.getBoundingClientRect();
        const top = Math.max(8, boundary?.top ?? 8);
        const bottom = Math.min(window.innerHeight - 8, boundary?.bottom ?? window.innerHeight - 8);
        const below = Math.max(0, bottom - anchor.bottom - 4);
        const above = Math.max(0, anchor.top - top - 4);
        const openAbove = below < Math.min(220, list.scrollHeight) && above > below;
        list.style.top = openAbove ? 'auto' : '100%';
        list.style.bottom = openAbove ? '100%' : 'auto';
        list.style.maxHeight = `${Math.min(220, openAbove ? above : below)}px`;
      };
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) document.querySelectorAll('details.amaro-select[open]').forEach(other => { if (other !== details) other.open = false; });
        placeSuggestionOptions();
      });
      summary.addEventListener('click', event => { if (select.disabled) event.preventDefault(); });
      select.addEventListener('change', () => {
        summary.textContent = select.selectedOptions[0]?.textContent.trim() || label;
        Array.from(list.children).forEach((button, index) => button.setAttribute('aria-selected', String(select.options[index]?.selected)));
        syncQuickSizePrompts();
      });
      details.addEventListener('keydown', event => {
        if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
        event.preventDefault(); details.open = true;
        const buttons = Array.from(list.querySelectorAll('button:not(:disabled),a[role="option"]'));
        if (!buttons.length) return;
        const current = buttons.indexOf(document.activeElement);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : current === -1 ? event.key === 'ArrowUp' ? buttons.length - 1 : 0 : (current + (event.key === 'ArrowUp' ? -1 : 1) + buttons.length) % buttons.length;
        placeSuggestionOptions();
        buttons[index].focus();
      });
    };
    const selectScope = '#product-quick-view-drawer,amaro-combos,amaro-contextual-selection,[data-amaro-pdp-options]';
    let quickActionFrame = 0, quickActionBody, quickActionResize;
    const scheduleQuickActions = () => {
      if (quickActionFrame) return;
      quickActionFrame = requestAnimationFrame(() => { quickActionFrame = 0; syncQuickActions(); });
    };
    const syncQuickActions = () => {
      const drawer = document.querySelector('#product-quick-view-drawer');
      const body = drawer?.querySelector('.drawer-body');
      const container = drawer?.querySelector('.drawer-container');
      const source = drawer?.querySelector('product-form [name="add"]');
      if (!body || !container) return;
      let footer = container.querySelector('.amaro-quick-actions');
      if (!source) {
        if (footer) footer.hidden = true;
        drawer.removeAttribute('data-amaro-sticky-ready');
        return;
      }
      if (!footer) {
        footer = document.createElement('div'); footer.className = 'amaro-quick-actions';
        const submit = document.createElement('button'); submit.type = 'button'; submit.className = 'amaro-quick-submit';
        submit.addEventListener('click', () => {
          const current = drawer.querySelector('product-form [name="add"]');
          if (!current || current.disabled || current.getAttribute('aria-disabled') === 'true' || current.classList.contains('loading')) return;
          submit.disabled = true;
          current.click();
          scheduleQuickActions();
        });
        const hint = document.createElement('button'); hint.type = 'button'; hint.className = 'amaro-quick-scroll';
        hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 7 6 6 6-6M6 13l6 6 6-6"/></svg>';
        hint.addEventListener('click', () => body.scrollBy({ top: Math.max(180, body.clientHeight * .65), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
        footer.append(submit, hint); container.append(footer);
      }
      const config = drawer.querySelector('[data-amaro-quick-actions-config]');
      const busy = source.classList.contains('loading');
      const text = busy ? config?.dataset.loading || source.textContent.trim() : source.querySelector('[data-addtocart-text]')?.textContent.trim() || source.textContent.trim();
      const submit = footer.querySelector('.amaro-quick-submit'), hint = footer.querySelector('.amaro-quick-scroll');
      if (submit.textContent !== text) submit.textContent = text;
      const disabled = source.disabled || source.getAttribute('aria-disabled') === 'true' || busy;
      if (submit.disabled !== disabled) submit.disabled = disabled;
      if (submit.getAttribute('aria-busy') !== String(busy)) submit.setAttribute('aria-busy', String(busy));
      const label = config?.dataset.scrollHint || drawer.querySelector('.amaro-quick-view-details')?.textContent.trim();
      if (label && hint.getAttribute('aria-label') !== label) { hint.setAttribute('aria-label', label); hint.title = label; }
      if (footer.hidden) footer.hidden = false;
      if (!drawer.hasAttribute('data-amaro-sticky-ready')) drawer.setAttribute('data-amaro-sticky-ready', '');
      const remaining = body.scrollHeight - body.clientHeight - body.scrollTop;
      hint.hidden = remaining <= 4;
      if (quickActionBody !== body) {
        quickActionBody?.removeEventListener('scroll', scheduleQuickActions);
        quickActionResize?.disconnect(); quickActionBody = body;
        body.addEventListener('scroll', scheduleQuickActions, { passive: true });
        quickActionResize = new ResizeObserver(scheduleQuickActions);
        quickActionResize.observe(body);
        const content = body.querySelector('.quickview-body-content');
        if (content) quickActionResize.observe(content);
      }
    };
    const enhanceControls = () => {
      document.querySelectorAll('#product-quick-view-drawer variant-selector').forEach(picker => { picker.dataset.updateUrl = 'false'; });
      document.querySelectorAll('#product-quick-view-drawer select:not([data-amaro-select]),amaro-combos select:not([data-amaro-select]),[data-amaro-pdp-options] select:not([data-amaro-select])').forEach(enhanceSelect);
      syncQuickSizePrompts();
      document.querySelectorAll('#product-quick-view-drawer product-media').forEach(media => {
        const slider = media.productImages;
        if (!slider || media.dataset.amaroCompactMedia) return;
        media.dataset.amaroCompactMedia = 'true';
        media.slidePerView = slider.params.slidesPerView = slider.originalParams.slidesPerView = 1;
        slider.update();
      });
    };
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target.closest?.('#product-quick-view-drawer'))) scheduleQuickActions();
      if (records.some(r => r.type === 'attributes' && r.target.matches('cart-drawer,#product-quick-view-drawer'))) synchronize();
      const changedSelects = new Set(records.filter(r => r.type === 'attributes' && r.attributeName !== 'class' && r.target.closest?.(selectScope)).map(r => r.target.closest('select')).filter(Boolean));
      for (const select of changedSelects) {
        const details = select.nextElementSibling;
        if (details?.classList.contains('amaro-select')) details.remove();
        delete select.dataset.amaroSelect;
        enhanceSelect(select);
      }
      if (records.some(r => r.type === 'childList' && (r.target.closest?.(selectScope) || Array.from(r.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selectScope) || node.querySelector?.(selectScope)))))) enhanceControls();
    });
    // These stable roots contain every enhanced select and drawer state.
    // Ignore unrelated mutations from the product gallery and external widgets.
    document.querySelectorAll('#product-quick-view-drawer,cart-drawer,#main-cart,.section-main-product,amaro-contextual-selection').forEach(root => {
      observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled', 'selected'] });
    });
    enhanceControls(); synchronize(); scheduleQuickActions();
    document.addEventListener('click', event => {
      const color = event.target.closest('#product-quick-view-drawer [data-amaro-product-colors] a,#product-quick-view-drawer .color-swatches-box .amaro-select-options a');
      if (color && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        const picker = color.closest('.product-media-info-inner')?.querySelector('variant-selector');
        if (typeof picker?.fetchUpdatedSection === 'function') {
          event.preventDefault();
          picker.dataset.url = new URL(color.href).pathname;
          picker.productData = null;
          picker.hasUserInteracted = true;
          picker.fetchUpdatedSection(color.href, 'quickview');
        }
      }
      document.querySelectorAll('details.amaro-select[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
    });
    const showNotice = (messageText, combo, options = [], error = false) => {
      const quick = document.querySelector('#product-quick-view-drawer.open .drawer-container');
      if ((cartVisible() || document.querySelector('amaro-contextual-selection') && !quick) && !error) { dismissNotice(); return; }
      if (!notice) {
        notice = document.createElement('aside'); notice.className = 'amaro-combo-notice';
        const message = document.createElement('p'); message.setAttribute('role', 'status'); message.setAttribute('aria-live', 'polite');
        const actions = document.createElement('div'); actions.className = 'amaro-notice-actions';
        const next = document.createElement('a'); next.className = 'amaro-notice-primary'; next.dataset.noticeNext = '';
        const bag = document.createElement('a'); bag.className = 'amaro-notice-secondary'; bag.href = `${window.Shopify?.routes?.root || '/'}cart`; bag.textContent = 'Ver mi bolsa'; bag.dataset.noticeBag = '';
        const keep = document.createElement('button'); keep.type = 'button'; keep.className = 'amaro-notice-secondary'; keep.textContent = 'Seguir comprando'; keep.dataset.noticeKeep = ''; keep.addEventListener('click', () => { dismissNotice(); const drawer = document.querySelector('#product-quick-view-drawer.open'); if (drawer) closeDrawer(drawer); });
        actions.append(next, bag, keep);
        const alternatives = document.createElement('details'); alternatives.className = 'amaro-notice-alternatives';
        const summary = document.createElement('summary'); summary.textContent = 'Otras formas de combinar';
        const list = document.createElement('ul'); list.className = 'amaro-notice-combinations'; alternatives.append(summary, list);
        const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Cerrar notificación'); close.addEventListener('click', dismissNotice);
        notice.append(message, actions, alternatives, close); document.body.append(notice);
        notice.addEventListener('focusin', () => clearTimeout(noticeTimer)); notice.addEventListener('pointerenter', () => clearTimeout(noticeTimer));
        const resume = () => { if (!notice.contains(document.activeElement)) { clearTimeout(noticeTimer); noticeTimer = setTimeout(dismissNotice, 7000); } };
        notice.addEventListener('focusout', resume); notice.addEventListener('pointerleave', resume);
      }
      if (quick) { notice.dataset.inline = 'true'; notice.style.bottom = ''; notice.style.maxHeight = ''; quick.insertBefore(notice, quick.querySelector('.amaro-quick-actions')); }
      else { delete notice.dataset.inline; document.body.append(notice); }
      notice.dataset.combo = String(combo); notice.dataset.error = String(error);
      notice.querySelector('p').textContent = messageText;
      const next = notice.querySelector('[data-notice-next]'), bag = notice.querySelector('[data-notice-bag]'), keep = notice.querySelector('[data-notice-keep]');
      next.href = !combo && options[0] ? options[0].href : bag.href;
      next.textContent = !combo && options[0] ? options[0].label : 'Revisar mi bolsa';
      bag.hidden = combo || !options.length; keep.hidden = !combo && options.length > 0;
      notice.querySelector('.amaro-notice-actions').hidden = error;
      const alternatives = notice.querySelector('details'); alternatives.open = false; alternatives.hidden = combo || options.length < 2;
      const list = notice.querySelector('ul'); list.replaceChildren();
      for (const option of options.slice(1)) { const item = document.createElement('li'), link = document.createElement('a'); link.href = option.href; link.textContent = option.label; item.append(link); list.append(item); }
      notice.hidden = false;
      positionNotice();
      if (combo && typeof navigator.vibrate === 'function') { try { navigator.vibrate([60, 40, 60]); } catch (_) {} }
      clearTimeout(noticeTimer); noticeTimer = setTimeout(dismissNotice, error ? 6500 : 12000);
    };

    window.addEventListener('amaro:combo-complete', event => showNotice(event.detail.message, true, event.detail.options));
    window.addEventListener('amaro:cart-options', event => showNotice(event.detail.options[0]?.description || 'Tu bolsa se actualizó.', false, event.detail.options));
    window.addEventListener('amaro:size-required', () => showNotice('Elige tu talla antes de agregar el par.', false, [], true));
    window.addEventListener('amaro:cart-removed', dismissNotice);

    let clearing = false;
    const updateClearButtons = cart => {
      if (typeof cart?.item_count !== 'number') return;
      document.querySelectorAll('[data-amaro-clear-cart]').forEach(button => { button.hidden = cart.item_count === 0; });
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => updateClearButtons(event.cartState));
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-amaro-clear-cart]');
      if (!button) return;
      event.preventDefault();
      if (clearing) return;
      clearing = true;
      dismissNotice();
      document.querySelectorAll('[data-amaro-clear-cart]').forEach(control => { control.disabled = true; control.textContent = 'Vaciando…'; });
      document.querySelectorAll('[data-amaro-clear-status]').forEach(status => { status.textContent = ''; });
      const root = window.Shopify?.routes?.root || '/';
      const mainSection = document.getElementById('main-cart')?.dataset.id;
      const sections = ['cart-drawer', ...(mainSection ? [mainSection] : [])];
      let cleared = false;
      try {
        const response = await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ sections, sections_url: location.pathname }) });
        const cart = await response.json();
        if (!response.ok || cart.item_count !== 0) throw new Error('clear');
        cleared = true;
        if (sections.some(section => !cart.sections?.[section])) { location.assign(`${root}cart`); return; }
        const drawer = document.querySelector('cart-drawer');
        drawer?.renderContents(cart);
        if (mainSection) {
          const html = new DOMParser().parseFromString(cart.sections[mainSection], 'text/html');
          for (const selector of ['#main-cart', '#main-cart-summary']) {
            const current = document.querySelector(selector), fresh = html.querySelector(selector);
            if (!current || !fresh) throw new Error('render');
            current.innerHTML = fresh.innerHTML;
          }
        }
        updateClearButtons(cart);
        window.dispatchEvent(new CustomEvent('amaro:cart-removed'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartState: cart });
        const heading = drawer?.classList.contains('open') ? drawer.querySelector('.drawer-heading') : document.querySelector('.amaro-page-cart h1');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      } catch (_) {
        if (cleared) { location.assign(`${root}cart`); return; }
        document.querySelectorAll('[data-amaro-clear-status]').forEach(status => { status.textContent = 'No pudimos vaciar tu bolsa. Revisa tu conexión e intenta de nuevo.'; });
      } finally {
        clearing = false;
        document.querySelectorAll('[data-amaro-clear-cart]').forEach(control => { control.disabled = false; control.textContent = 'Vaciar bolsa'; });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
